import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Pricing page components
import FaqCollapse from "components/FaqCollapse";

function Faq(loggedIn=false) {
  const [collapse, setCollapse] = useState(false);
  return (
    <VuiBox mt={{ sm: 2, xl: 4 }}>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={6}>
          <VuiBox mb={1}>
            <VuiTypography variant="h3" align="center" textTransform="capitalize"
              fontWeight="800"
              color="#3b3663">
              Frequently Asked Questions
            </VuiTypography>
          </VuiBox>
        </Grid>
        <Grid item xs={12} xl={10}>
          <FaqCollapse
            title="What is the SP Indian Freight Index?"
            open={collapse === 1}
            onClick={() => (collapse === 1 ? setCollapse(false) : setCollapse(1))}
          >
            The SP Indian Freight Index is a benchmarking tool that measures the cost of transporting goods within India. It tracks the changes in transportation costs for various geographic locations, vehicle types, zones, and distances. It is calculated based on data collected from various transport providers and is used by businesses to monitor the trends in transportation costs and make informed decisions about logistics and supply chain management.
          </FaqCollapse>          
          {/* <Divider light /> */}
          <FaqCollapse
            title="What is the purpose of the SP Indian Freight Index?"
            open={collapse === 2}
            onClick={() => (collapse === 2 ? setCollapse(false) : setCollapse(2))}
          >
            This index gives manufacturers and freighters a real-time understanding of the freight rates for all significant lanes at any given point in time. As a result, shippers are able to increase their bargaining power and negotiate more effectively. In addition, it compares current and historical freight prices and explains the predictability of peak and dull seasons. All of this combined helps businesses to monitor transportation costs and optimize them as much as possible.
          </FaqCollapse>
           {/* <Divider light /> */}
          <FaqCollapse
            title="How do you calculate the freight rates?"
            open={collapse === 3}
            onClick={() => (collapse === 3 ? setCollapse(false) : setCollapse(3))}
          >
            On a daily basis, shippers and transport partners rely on SuperProcure to settle their freight. Our platform leverages algorithms that incorporate actual quotes from transport partners and allotments made by our customers from every corner of India. By analyzing, refining, and calculating this data, our algorithms are able to generate a Freight Index that is tailored to specific zones and vehicle types.
          </FaqCollapse>
          {/* <Divider light /> */}
          <FaqCollapse
            title="Who should be using it? Who will benefit most from it?"
            open={collapse === 4}
            onClick={() => (collapse === 4 ? setCollapse(false) : setCollapse(4))}
          >
            Anyone in the logistics sector looking to benchmark spot freight rates or understanding the trends associated with road rates can use this data.<br />
            Freight rate index tools allow you to get a precise picture of the real-time market rates for all significant lanes at any time from anywhere.<br />
            Scanning through thousands of freight rates for several routes from sources that may or may not be reliable and then crunching those numbers to arrive at a conclusion can be exhausting.<br />
            The solution?  An efficient freight index tool will instantly give you an edge over your competitors. Moreover, it will equip you with invaluable actionable data and business intelligence to make the right decisions.
          </FaqCollapse>
          { !loggedIn ?
            <>
          {/* <Divider light /> */}
          <FaqCollapse
            title="I want to view detailed data, what should I do?"
            open={collapse === 5}
            onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
          >
            You can unlock all levels with a simple phone number based authentication. Click the lock icon on the bottom right corner of your screen to unlock. You can also get in touch with us at <Link href={"https://www.superprocure.com"} target="_blank">
            <VuiTypography variant="button" color="white">superprocure.com</VuiTypography></Link>
          </FaqCollapse>
            </>
            : ""}
          {/* <Divider light /> */}
          {/* <FaqCollapse
            title="Wish to use SuperProcure for my organization."
            open={collapse === 6}
            onClick={() => (collapse === 6 ? setCollapse(false) : setCollapse(6))}
          >
            Please write to us on hello@superprocure.com or visit us at <Link href={"https://www.superprocure.com"} target="_blank">
            <VuiTypography variant="button" color="text">superprocure.com</VuiTypography></Link>. Our team will reach out to you.
          </FaqCollapse> */}
          {/* <Divider light /> */}

          <VuiBox 
            mb={0} 
            mt={5}        
            sx={({ breakpoints }) => ({
                py: 2,
                background: '#3167a4',
                borderRadius: '5px',
            })}
            px={2}
            >
            <VuiTypography
                variant={'h4'}
                textTransform="capitalize"
                fontWeight="800"
                color={'white'}
                textAlign="center"
                mb={1}
            >
                Wish to use SuperProcure for my organization.
            </VuiTypography>
            <p style={{fontSize: '18px', color: '#ffffff', lineHeight: '24px', textAlign: 'center'}}>
                Please write to us on hello@superprocure.com or visit us at <Link href={"https://www.superprocure.com"} target="_blank">
                <VuiTypography 
                    variant="button"
                    sx={{
                        fontSize: '18px', 
                        color: '#ffffff', 
                        lineHeight: '24px', 
                        textAlign: 'center',
                    }}>superprocure.com</VuiTypography></Link>. Our team will reach out to you.</p>
        </VuiBox>
        </Grid>
      </Grid>
    </VuiBox>
  );
}

export default Faq;
